module.exports = __webpack_public_path__ + "img/8.b2fc0968.png";